import _import from './_import.js';

export default [
	// 购买设备
    {
        path: 'purchase/device_purchase',
        component: _import('glocalme/device_purchase'),
        children: [
            {
                path: '*',
                component: _import('glocalme/device_purchase'),
            }
        ]
    },
    {
        path: 'purchase/device_order_confirmation',
        component: _import('glocalme/device_order_confirmation'),
        children: [
            {
                path: '*',
                component: _import('glocalme/device_order_confirmation'),
            }
        ]
    },
    {
        path: 'purchase/device_order_payment',
        component: _import('glocalme/device_order_payment'),
        children: [
            {
                path: '*',
                component: _import('glocalme/device_order_payment'),
            }
        ]
    },
    // 支付结果页面---设备订单详情
    {
        path: 'purchase/device_order_success',
        name: 'orderResult',
        component: _import('glocalme/orderResult'),
        children: [
            {
                path: '*',
                component: _import('glocalme/orderResult'),
            }
        ]
    },
];



// WEBPACK FOOTER //
// ./src/router/purchase.js